<div class="dialog-header" [style.backgroundColor]="widgetConfig?.style.mainColor + '14'">
  <!--<h2 *ngIf="elementValues">{{ elementValues[CONSTANTS.name] }}</h2>-->
  <header class="directory-entity-header">
    <div class="directory-entity-header-logo-title">
      <app-directory-entity-field
        class="directory-entity-header-logo"
        [field]="summary?.logo?.field"
        [fieldValue]="summary?.logo?.value"></app-directory-entity-field>
      <app-directory-entity-field
        class="directory-entity-header-title"
        [field]="summary?.title?.field"
        [fieldValue]="summary?.title?.value"></app-directory-entity-field>
    </div>
    <div
      class="directory-entity-header-banner"
      [style.backgroundImage]="'url('+urlEnc(summary?.banner?.value)+')'">
    </div>
    <div
      class="directory-entity-header-banner col-6 p-0">
      <app-directory-entity-field
        class="directory-entity-header-banner"
        [field]="summary?.banner?.field"
        [fieldValue]="summary?.banner?.value"></app-directory-entity-field>
    </div>
    <div class="directory-entity-field-value directory-entity-header-description" *ngIf="summary?.description?.field?.id">
      <app-directory-entity-field
        [field]="summary?.description?.field"
        [fieldValue]="summary?.description?.value"></app-directory-entity-field>
    </div>
  </header>
  <div class="flex-spacer"></div>
  <!-- <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button> -->
</div>
<button mat-stroked-button
  *ngIf="canContact()"
  class="directory-entity-contact-button mt-2"
  appearance="with-icon"
  color="primary"
  (click)="openContactDialog()">
<mat-icon>mail</mat-icon>
<span>{{ 'directory.contact.entity_contact'|translate }}</span>
</button>
<!--
<ng-container *ngFor="let field of currentAdbFields | orderByImpure: 'order'">
  <ng-container *ngIf="field">
    <app-directory-entity-field
    [field]="field"
    [fieldValue]="elementValues[field.id]"
    [class]="'field--'+field.id"></app-directory-entity-field>
  </ng-container>
</ng-container>
-->

<div class="entity-groups-col">
  <ng-container *ngFor="let group of filteredFieldsGroups | orderByImpure: 'order'">
    <div class="directory-entity-fields-group util-el-surface mt-3 col-12"
      [class.col-md-6]="filteredFieldsGroups.length > 1 && !widgetConfig.layout.isFullSize">
      <h3 *ngIf="sheetToUse?.displayGroupsTitle && group.title" class="mt-0">
        {{ translationCompatibilityForOlderWidget(group.title, currentLang) }}
      </h3>
      <ng-container *ngFor="let field of group.fields | orderByImpure: 'order'">
        <app-directory-entity-field 
          [field]="field" 
          [fieldValue]="elementValues[field.id]"
          [class]="'field--'+field.id"></app-directory-entity-field>
      </ng-container>
    </div>
  </ng-container>
</div>
